
import { useCart } from '../../context/CartContext';

export default function CartButton() {
  const { totalItems, setIsCartOpen } = useCart();

  return (
    <button 
      onClick={() => setIsCartOpen(true)}
      className="fixed bottom-24 right-6 z-40 w-14 h-14 bg-black border-2 border-lime-500 rounded-full shadow-xl shadow-lime-500/30 flex items-center justify-center hover:scale-110 transition-transform group"
    >
      <i className="ri-shopping-cart-2-line text-lime-400 text-2xl"></i>
      {totalItems > 0 && (
        <span className="absolute -top-1 -right-1 w-6 h-6 bg-lime-500 text-black text-xs font-bold rounded-full flex items-center justify-center">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
      <span className="absolute bottom-full right-0 mb-2 px-3 py-1.5 bg-black border border-lime-500/30 text-lime-400 text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap font-semibold">
        Ver Carrito
      </span>
    </button>
  );
}
